import React from 'react';
import './LegalPages.css';

function PrivacyPolicy() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last Updated: December 4, 2025</p>

                <section>
                    <h2>1. Information Collection</h2>
                    <p>
                        We value your privacy. All image and PDF processing tools provided on this website run locally in your browser,
                        <strong> and do not upload your files to any server</strong>.
                    </p>
                    <p>Our technology:</p>
                    <ul>
                        <li>All file processing is completed entirely on the client side (your browser)</li>
                        <li>Processed files are only saved on your device</li>
                        <li>We do not store, transmit, or access any of your file content</li>
                    </ul>
                </section>

                <section>
                    <h2>2. Cookies Usage</h2>
                    <p>
                        This website may use Cookies and similar technologies to improve user experience. This includes:
                    </p>
                    <ul>
                        <li>Remembering your preference settings</li>
                        <li>Analyzing website usage (through tools like Google Analytics)</li>
                        <li>Providing personalized advertising content (through Google AdSense)</li>
                    </ul>
                    <p>
                        You can choose to disable Cookies through your browser settings, but this may affect some website features.
                    </p>
                </section>

                <section>
                    <h2>3. Third-Party Services</h2>
                    <p>This website uses the following third-party services:</p>
                    <ul>
                        <li>
                            <strong>Google AdSense</strong>: Used to display advertisements. Google may use Cookies
                            to provide relevant ads. For details, please see
                            <a
                                href="https://policies.google.com/technologies/ads"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Google's Advertising Policies
                            </a>.
                        </li>
                        <li>
                            <strong>Google Analytics</strong> (if applicable): Used to analyze website traffic and user behavior.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>4. Data Security</h2>
                    <p>
                        Since all file processing is done locally in your browser, your data is always under your control.
                        We take reasonable security measures to protect limited information we may collect (such as access logs).
                    </p>
                </section>

                <section>
                    <h2>5. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Know what information we collect</li>
                        <li>Request deletion of your personal information</li>
                        <li>Opt out of data collection</li>
                        <li>Update or correct your information</li>
                    </ul>
                </section>

                <section>
                    <h2>6. Children's Privacy</h2>
                    <p>
                        This website is not targeted at children under 13 years old. We do not knowingly collect personal information from children.
                        If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
                    </p>
                </section>

                <section>
                    <h2>7. Policy Changes</h2>
                    <p>
                        We may update this privacy policy from time to time. Any changes will be posted on this page and the "Last Updated" date will be updated.
                        We recommend that you review this policy periodically to stay informed.
                    </p>
                </section>

                <section>
                    <h2>8. Contact Us</h2>
                    <p>
                        If you have any questions or comments about this privacy policy, please contact us through our
                        <a href="/contact"> contact page </a>.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
